export const metricPitchLabels = Object.freeze({
  default_coarse: 'Default / Coarse',
  fine: 'Fine',
  other: 'Other',
});

export const metricClassificationLabel = (classification) => {
  if (classification?.customThread) return 'Custom metric thread';
  return metricPitchLabels[classification?.pitchCategory] || 'Listed metric thread';
};

export const formatMetricIdentityNumber = value => Number(value).toString();
